var _g, _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fefefe",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 9,
    y: 2,
    x: 2,
    width: 95.83094,
    height: 178.22694
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.989633,12.230028 h 31.90036"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fefefe",
    strokeWidth: 4,
    strokeDasharray: "8,4",
    d: "m 59.819941,117.56588 c 0.61595,-7.47571 12.55948,-14.87075 15.42705,-22.09506 2.14541,-5.40501 5.48878,-6.98623 6.69051,-10.19606 1.20175,-3.20982 1.80564,-5.63495 4.68656,-9.09036 0.75782,-0.90893 1.23522,-5.23604 -5.5948,-4.21791 -6.83003,1.01809 -13.29676,19.63518 -16.96803,14.94443 -8.47203,-10.49567 -4.49558,-37.84322 -5.07275,-46.06651 -0.36251,-5.16474 -6.43054,-5.0822 -7.26381,0.35171 -1.08189,7.05517 -3.50471,24.69505 -3.58692,28.62986 -0.45919,-2.47158 0.49191,-28.28017 0.76444,-32.07535 0.4045,-5.63277 -7.41582,-6.22425 -7.81708,-0.1378 -0.2013,3.05318 -2.87772,28.97773 -2.98444,33.51387 0.0575,-2.40664 -2.60661,-25.3111 -2.82554,-29.41442 -0.29346,-5.50038 -7.32791,-5.03436 -7.02426,0.83033 0.20551,2.77685 1.54135,24.58014 2.05514,28.38543 0.51379,3.8053 -3.39097,5.45079 -4.21303,3.18819 -0.82205,-2.2626 -7.47144,-16.09708 -9.14533,-19.84921 -1.2689,-2.84426 -6.74796,-1.20119 -5.54886,2.36547 1.88746,5.61418 11.19452,24.15814 11.6562,38.56714 0.25759,8.03891 2.71995,11.11416 6.37731,22.57463 2.61647,8.19882 2.3442,12.00618 2.6118,22.40683 l 26.87023,0.14544 c 0.3927,-8.5743 0.18311,-13.99086 0.90561,-22.76065 z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#fefefe",
    stroke: "none",
    cx: 49.939812,
    cy: 161.07985,
    r: 5.5440788
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#fefefe",
    strokeWidth: 2,
    cx: 49.939812,
    cy: 161.07985,
    r: 9.0881577
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandFrame);
export default __webpack_public_path__ + "static/media/hand-frame.c9d986532afcfd04a6abd5349f37503e.svg";
export { ForwardRef as ReactComponent };